import { useEffect } from 'react';
import {
  Drawer,
  DrawerBody,
  DrawerContent,
  DrawerCloseButton,
  DrawerOverlay,
  DrawerHeader,
  HStack,
  VStack,
  Text,
  Icon,
} from '@chakra-ui/react';

import {
  IoFileTrayOutline,
  IoReceiptOutline,
  IoPersonOutline,
  IoLogIn,
  IoLogOut,
} from 'react-icons/io5';
import { useNavigate, useParams } from 'react-router-dom';
import { Logo } from '~/icons';

import mediaQueryStateAtom from '~/recoil/atom/mediaQueryState';
import { useRecoilValue } from 'recoil';
import getPath from '~/utils/getNavigatePath';
import globalEnterpriseGroupBuyAtom from '~/recoil/atom/enterpriseGroupBuy/globalEnterpriseGroupBuyAtom';
import { EnterpriseGroupBuyStatus } from '~/types/enterpriseGroupBuy';

const navList = [
  {
    title: '首頁',
    icon: Logo,
    link: '',
  },
  {
    title: '訂單',
    icon: IoReceiptOutline,
    link: 'orderList',
  },
  {
    title: '專屬優惠',
    icon: IoPersonOutline,
    link: 'coupons',
  },
  {
    title: '餐盒回收',
    icon: IoFileTrayOutline,
    link: 'mealBoxRecycling',
  },
];

const enterpriseGroupBuyNavList = [
  {
    title: '首頁',
    icon: Logo,
    link: '',
  },
  {
    title: '訂單',
    icon: IoReceiptOutline,
    link: 'orderList',
  },
];

type NavDrawerProps = {
  isOpen: boolean;
  isLogin: boolean;
  onClose: () => void;
  onLoginLogout: () => void;
};

export default function NavDrawer({ isOpen, isLogin, onClose, onLoginLogout }: NavDrawerProps) {
  const navigate = useNavigate();
  const { groupId = '', enterpriseGroupBuyId = '' } = useParams();
  const { data } = useRecoilValue(globalEnterpriseGroupBuyAtom);

  const { isLargerThan768 } = useRecoilValue(mediaQueryStateAtom);

  const handleNavigate = (path: string) => {
    return navigate(getPath(`/${path}`, groupId, enterpriseGroupBuyId));
  };

  useEffect(() => {
    if (isLargerThan768) {
      onClose();
    }
  }, [isLargerThan768]);

  return (
    <Drawer isOpen={isOpen} onClose={onClose} placement="left" size="xs">
      <DrawerOverlay />
      <DrawerContent maxW="250px">
        <DrawerHeader />
        <DrawerCloseButton
          bgColor="primary"
          color="white"
          borderRadius="full"
          _hover={{}}
          _focus={{}}
        />
        <DrawerBody>
          <VStack align="stretch" spacing={6}>
            {(enterpriseGroupBuyId ? enterpriseGroupBuyNavList : navList).map(
              ({ title, icon, link }) => {
                return (
                  <HStack
                    onClick={() => {
                      if (
                        !!enterpriseGroupBuyId &&
                        data?.status !== EnterpriseGroupBuyStatus.ONGOING
                      ) {
                        handleNavigate('orderList');
                      } else handleNavigate(link);
                    }}
                    key={title}
                    align="center"
                    cursor="pointer"
                  >
                    <Icon as={icon} boxSize="1.5rem" color="dark" />
                    <Text fontSize="lg">{title}</Text>
                  </HStack>
                );
              },
            )}
            <HStack align="center" cursor="pointer" onClick={onLoginLogout}>
              <Icon as={isLogin ? IoLogOut : IoLogIn} boxSize="1.5rem" color="dark" />
              <Text fontSize="lg">{isLogin ? '登出' : '登入'}</Text>
            </HStack>
          </VStack>
        </DrawerBody>
      </DrawerContent>
    </Drawer>
  );
}
